/* TPS PDP — mobile sticky Add-to-Cart bar (Himanshu-R&D)
   Builds a fixed bottom bar on product pages and reveals it once the
   real Add-to-Cart button scrolls out of view. The sticky button
   clicks the theme's own ATC button, so variant handling, AJAX and the
   cart drawer are all inherited. Mobile-only via CSS.
   Loaded from snippets/icon-with-text.liquid (idempotency-guarded). */
(function () {
  if (window.__tpsStickyATC) return;
  window.__tpsStickyATC = true;

  var BTN_SEL =
    '.product__info-container product-form [name="add"],' +
    '.product__info-container .product-form__submit,' +
    '.product__info-container [name="add"],' +
    'form[action*="/cart/add"] [type="submit"]';

  function queryBtn() { return document.querySelector(BTN_SEL); }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;                 // not a product page
    if (!queryBtn()) return;           // no Add-to-Cart (e.g. call-for-price)

    function readPrice() {
      var root = info.querySelector('.price');
      if (!root) return '';
      var el = root.classList.contains('price--on-sale')
        ? root.querySelector('.price__sale .price-item--last')
        : root.querySelector('.price__regular .price-item--regular');
      if (!el) el = root.querySelector('.price-item--last, .price-item--regular');
      return el ? el.textContent.trim() : '';
    }

    var titleEl = document.querySelector('.product__title h1, .product__title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var imgEl = document.querySelector('.product__media img, .product-media-container img, .product__media-wrapper img');
    var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

    var bar = document.createElement('div');
    bar.className = 'tps-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="tps-sticky-atc__info">' +
        (imgSrc ? '<img class="tps-sticky-atc__img" src="' + escapeHtml(imgSrc) + '" alt="" width="44" height="44">' : '') +
        '<div class="tps-sticky-atc__text">' +
          '<span class="tps-sticky-atc__title">' + escapeHtml(title) + '</span>' +
          '<span class="tps-sticky-atc__price"></span>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="tps-sticky-atc__btn">Add to cart</button>';
    document.body.appendChild(bar);

    var priceSpan = bar.querySelector('.tps-sticky-atc__price');
    var stickyBtn = bar.querySelector('.tps-sticky-atc__btn');
    priceSpan.textContent = readPrice();

    // Click-through to the real button (re-queried in case the theme
    // replaced it during a variant change).
    stickyBtn.addEventListener('click', function () {
      var btn = queryBtn();
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      btn.click();
    });

    // Keep label, disabled state and price in sync with the real button.
    function sync() {
      var btn = queryBtn();
      if (btn) {
        stickyBtn.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
        var span = btn.querySelector('span');
        var label = (span && span.textContent.trim()) || btn.textContent.trim();
        if (label) stickyBtn.textContent = label;
      }
      priceSpan.textContent = readPrice();
    }
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 120); })
      .observe(info, { childList: true, subtree: true, characterData: true });
    sync();

    // Always-visible on mobile (Himanshu's preference). To revert to
    // scroll-triggered, reveal only when queryBtn()'s rect.bottom < 8 on scroll.
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tps-sticky-visible');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
